import React, { useState } from "react";
import { Share2, MessageSquare, Facebook, Link2, Check } from "lucide-react";
import { toast } from "sonner";

// One-tap sharing: native share sheet (phones), text message, Facebook, copy link.
export const ShareButtons = ({ url, title, text, label = "Spread the word", compact = false, testId = "share" }) => {
    const [copied, setCopied] = useState(false);
    const canNativeShare = typeof navigator !== "undefined" && typeof navigator.share === "function";
    const message = `${text} ${url}`;

    const nativeShare = async () => {
        try { await navigator.share({ title, text, url }); } catch { /* user dismissed */ }
    };
    const copy = async () => {
        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            toast.success("Link copied — paste it anywhere!");
            setTimeout(() => setCopied(false), 2000);
        } catch { toast.error("Couldn't copy — long-press the address bar to copy."); }
    };

    const btn = `inline-flex items-center justify-center gap-1.5 border-2 border-[#3D2008] font-manrope font-bold uppercase tracking-wide transition-colors duration-150 ${compact ? "text-[11px] px-2.5 h-9" : "text-xs px-3.5 h-11"}`;
    const light = `${btn} bg-white text-[#3D2008] hover:bg-[#3D2008] hover:text-white`;

    return (
        <div data-testid={testId} className={compact ? "flex flex-wrap items-center gap-2" : "flex flex-col sm:flex-row sm:items-center gap-3"}>
            {label && <span className={`font-manrope font-bold uppercase tracking-wide text-[#5C4A35] ${compact ? "text-[11px]" : "text-xs"}`}>{label}</span>}
            <div className="flex flex-wrap gap-2">
                {canNativeShare && (
                    <button type="button" onClick={nativeShare} data-testid={`${testId}-native`} className={`${btn} bg-[#C4522A] text-white hover:bg-[#A8431F]`}>
                        <Share2 size={compact ? 13 : 15} /> Share
                    </button>
                )}
                <a href={`sms:?&body=${encodeURIComponent(message)}`} data-testid={`${testId}-sms`} className={light}>
                    <MessageSquare size={compact ? 13 : 15} /> Text
                </a>
                <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer"
                    data-testid={`${testId}-facebook`} className={light}>
                    <Facebook size={compact ? 13 : 15} /> Facebook
                </a>
                <button type="button" onClick={copy} data-testid={`${testId}-copy`} className={light}>
                    {copied ? <Check size={compact ? 13 : 15} /> : <Link2 size={compact ? 13 : 15} />} {copied ? "Copied" : "Copy link"}
                </button>
            </div>
        </div>
    );
};
